import apiService from "./ApiService"
import { createQS } from "./Utils"

export const PapelEnum = {
  ADMIN: 1,
  FISCAL: 2,
  GESTOR_EMPRESA: 3,
  EXECUTOR: 4,
  GESTOR_CONTRATO: 5,
  FISCAL_CAMPO: 6,
}

export const todosPapeisFront = [
  PapelEnum.ADMIN,
  PapelEnum.FISCAL,
  PapelEnum.GESTOR_EMPRESA,
  PapelEnum.GESTOR_CONTRATO,
]

class PerfilService {
  async get() {
    try {
      return await apiService.get('combo/perfil')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  // Tela de Cadastro de Perfis (SDD 015). Chamado "list" (nao "get", ja usado acima pelo
  // combo) pra nao colidir com o metodo de combo que ja existia neste service.
  async list(termo, pagina) {
    try {
      const qs = createQS({ termo, pagina })
      return await apiService.get('perfil?' + qs)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get('perfil/' + id)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async create(data) {
    try {
      return await apiService.post('perfil', data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async update(id, data) {
    try {
      return await apiService.put('perfil/' + id, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async delete(id) {
    try {
      return await apiService.delete('perfil/' + id)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async clone(id, nome) {
    try {
      return await apiService.post('perfil/' + id + '/clonar', { nome })
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getTipos() {
    try {
      return await apiService.get('tipo_perfil')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getAcoesPorTipo(idTipo) {
    try {
      return await apiService.get('tipo_perfil/' + idTipo + '/acao')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
}

const perfilService = new PerfilService()
export default perfilService